import React, { useState } from "react";
import "../index.css";
import "../query.css";
import mask from "../img/mask19.png";
import sec3img from "../img/mask18.png";
import sec4img1 from "../img/Mask Group 29.png";
import sec4img2 from "../img/Mask Group 30.png";
import sec4img3 from "../img/Mask Group 31.png";
import sec4img4 from "../img/Mask Group 32.png";
import formimg from "../img/Mask Group 24.png";
import TeamCard from "../api/TeamCard";
import Team from "../api/TeamApi.js";
import ClientCard from "../api/ClientCard";
import Client from "../api/ClientApi.js";
import BlogCard from "../api/BlogCard";
import Blog from "../api/BlogApi";
import NewsCard from "../api/NewsCard";
import News from "../api/News";

const Home = () => {
  const [teamData] = useState(Team);
  const [clientData] = useState(Client);
  const [blogData] = useState(Blog);
  const [newsData] = useState(News);
  return (
    <>
      <header>
        <section className="header-sec">
          <p className="header-sec-p1">Market & Resources </p>
          <h1 className="header-sec-h1">Find The Best Doctor near By You</h1>
          <span>
            <button className="header-btn-1">Get A Quote</button>
            <button className="header-btn-2">Read More</button>
          </span>
        </section>
        <img src={mask} alt="mask 19" className="header-img" />
      </header>
      <BlogCard blogData={blogData} />
      <section className="sec-3">
        <img src={sec3img} alt="" className="sec-3-img" />
        <div className="sec-3-a">
          <h1 className="sec-3-h1">
            We provide essential services for your health
          </h1>
          <div className="sec-3-a-main">
            <div className="sec-3-a-01">
              <h4 className="sec-3-h4">Quality Control System </h4>
              <p className="sec-3-p1">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi,
                eaque.
              </p>
            </div>
            <div className="sec-3-a-02">
              <h4 className="sec-3-h4">High Professional Staff </h4>
              <p className="sec-3-p1">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Qui,
                facere?
              </p>
            </div>
          </div>
          <button className="sec-3-btn">Get A Quote</button>
        </div>
      </section>
      <section className="sec-4">
        <p className="sec-4-p1">Meet Our Team</p>
        <h2 className="sec-4-h2">Out Creative Team</h2>
        <div className="sec-4-child">
          <div className="sec-4-child-a">
            <img src={sec4img1} alt="" className="sec-4-img" />
            <div className="sec-4-a-01">
              <h5 className="sec-4-h5">Megam Neison</h5>
              <p className="sec-4-p2">Laorest Gravida</p>
            </div>
          </div>
          <div className="sec-4-child-b">
            <img src={sec4img2} alt="" className="sec-4-img" />
            <div className="sec-4-a-02">
              <h5 className="sec-4-h5">Megam Neison</h5>
              <p className="sec-4-p2">Laorest Gravida</p>
            </div>
          </div>
          <div className="sec-4-child-c">
            <img src={sec4img3} alt="" className="sec-4-img" />
            <div className="sec-4-a-03">
              <h5 className="sec-4-h5">Megam Neison</h5>
              <p className="sec-4-p2">Laorest Gravida</p>
            </div>
          </div>
          <div className="sec-4-child-d">
            <img src={sec4img4} alt="" className="sec-4-img" />
            <div className="sec-4-a-04">
              <h5 className="sec-4-h5">Megam Neison</h5>
              <p className="sec-4-p2">Laorest Gravida</p>
            </div>
          </div>
        </div>
      </section>

      <TeamCard teamData={teamData} />
      <ClientCard clientData={clientData} />
      <div className="mailbox">
        <div className="mail">
          <h1 className="mail-h1">
            Get notified about the event Subscribe today!
          </h1>
          <span className="input-box">
            <input
              type="text"
              placeholder="Email Address"
              className="mail-input"
            />
            <button className="mail-btn">Subscribe</button>
          </span>
        </div>
        <div className="img-form">
          <img src={formimg} alt="" className="form-img" />
          <form action="" className="form">
            <h1 className="form-h1">Get in touch with us</h1>
            <p className="form-p1">We will be happy to answer your question</p>
            <input type="text" name="" id="" placeholder="Name" />
            <input type="text" name="" id="" placeholder="Email" />
            <input type="text" name="" id="" placeholder="Message" />
            <button className="form-btn">Send</button>
          </form>
        </div>
      </div>
      <NewsCard newsData={newsData} />
    </>
  );
};

export default Home;
